module.exports = __webpack_public_path__ + "img/Antonia&Stephan-10.35592a13.jpg";